class CartProgressBar extends HTMLElement {
  connectedCallback() {
    this.free_gift_exist_1 = this.getAttribute('data-free-gift-exist-1');
    this.free_gift_variant_id_1 = this.getAttribute('data-free-gift-variant-id-1');
    this.free_gift_threshold_1 = Number(this.getAttribute('data-free-gift-threshold-1'));
    this.free_gift_line_key_1 = this.getAttribute('data-free-gift-line-key-1');

    this.free_gift_exist_2 = this.getAttribute('data-free-gift-exist-2');
    this.free_gift_variant_id_2 = this.getAttribute('data-free-gift-variant-id-2');
    this.free_gift_threshold_2 = Number(this.getAttribute('data-free-gift-threshold-2'));
    this.free_gift_line_key_2 = this.getAttribute('data-free-gift-line-key-2');

    this.free_gift_exist_3 = this.getAttribute('data-free-gift-exist-3');
    this.free_gift_variant_id_3 = this.getAttribute('data-free-gift-variant-id-3');
    this.free_gift_threshold_3 = Number(this.getAttribute('data-free-gift-threshold-3'));
    this.free_gift_line_key_3 = this.getAttribute('data-free-gift-line-key-3');

    this.cartTotal = Number(this.dataset.cartTotal);

    this.evaluateFreeGift();

    document.addEventListener('cart:refresh', this.manageFreeGiftQuantity());
  }

  async manageFreeGiftQuantity() {
    if (this.free_gift_exist_1 === 'true' && this.free_gift_line_key_1) {
      await this.modifyCart('modify', this.free_gift_variant_id_1, this.free_gift_line_key_1, 1);
    }
    if (this.free_gift_exist_2 === 'true' && this.free_gift_line_key_2) {
      await this.modifyCart('modify', this.free_gift_variant_id_2, this.free_gift_line_key_2, 2);
    }
    if (this.free_gift_exist_3 === 'true' && this.free_gift_line_key_3) {
      await this.modifyCart('modify', this.free_gift_variant_id_3, this.free_gift_line_key_3, 3);
    }
  }

  async evaluateFreeGift() {
    const qualifiesForGift1 = this.cartTotal >= this.free_gift_threshold_1 && this.free_gift_threshold_1 > 0;

    if (qualifiesForGift1 && !this.free_gift_line_key_1) {
      await this.modifyCart('add', this.free_gift_variant_id_1, this.free_gift_line_key_1, 1);
    } else if (!qualifiesForGift1 && this.free_gift_line_key_1) {
      await this.modifyCart('remove', this.free_gift_variant_id_1, this.free_gift_line_key_1, 1);
    }

    const qualifiesForGift2 = this.cartTotal >= this.free_gift_threshold_2 && this.free_gift_threshold_2 > 0;

    if (qualifiesForGift2 && !this.free_gift_line_key_2) {
      await this.modifyCart('add', this.free_gift_variant_id_2, this.free_gift_line_key_2, 2);
    } else if (!qualifiesForGift2 && this.free_gift_line_key_2) {
      await this.modifyCart('remove', this.free_gift_variant_id_2, this.free_gift_line_key_2, 2);
    }

    const qualifiesForGift3 = this.cartTotal >= this.free_gift_threshold_3 && this.free_gift_threshold_3 > 0;

    if (qualifiesForGift3 && !this.free_gift_line_key_3) {
      await this.modifyCart('add', this.free_gift_variant_id_3, this.free_gift_line_key_3, 3);
    } else if (!qualifiesForGift3 && this.free_gift_line_key_3) {
      await this.modifyCart('remove', this.free_gift_variant_id_3, this.free_gift_line_key_3, 3);
    }
  }

  /**
   * Find the first non-gift, non-gift-wrap line item in the cart
   * to serve as the parent for a nested free-gift child line.
   */
  async findParentLineKey() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return null;
      const cart = await res.json();

      const parentLine = cart.items.find((item) => {
        const props = item.properties || {};
        return !props._is_free_gift && !props._isFreeGift && !props._is_gift_wrap;
      });

      return parentLine ? parentLine.key : null;
    } catch (err) {
      console.error('Failed to fetch cart for parent line:', err);
      return null;
    }
  }

  async modifyCart(action, freeGiftVariantId, freeGiftKey, freeGiftIndex) {
    if (action === 'add') {
      // Find a qualifying parent line to nest the gift under
      const parentLineKey = await this.findParentLineKey();

      const addBody = {
        items: [{
          id: parseInt(freeGiftVariantId),
          quantity: 1,
          properties: {
            _is_free_gift: "true",
            _giftIndex: String(freeGiftIndex)
          }
        }]
      };

      // Attach as nested child if a parent line exists
      if (parentLineKey) {
        addBody.items[0].parent_line_key = parentLineKey;
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addBody)
        });

        if (!res.ok) {
          // Fallback: if nested add fails (e.g. parent_line_key unsupported),
          // retry without nesting — the Discount Function still applies 100% off
          if (parentLineKey) {
            delete addBody.items[0].parent_line_key;
            const fallbackRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(addBody)
            });
            if (!fallbackRes.ok) throw new Error('Cart add failed (fallback)');
          } else {
            throw new Error('Cart add failed');
          }
        }

        this.dispatchCartUpdated();
      } catch (error) {
        console.error('Failed to add free gift:', error);
      }

    } else if (action === 'remove') {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: freeGiftKey, quantity: 0 })
        });

        if (!res.ok) throw new Error('Cart remove failed');
        this.dispatchCartUpdated();
      } catch (error) {
        console.error('Failed to remove free gift:', error);
      }

    } else if (action === 'modify') {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: freeGiftKey, quantity: 1 })
        });

        if (!res.ok) throw new Error('Cart modify failed');
      } catch (error) {
        console.error('Failed to modify free gift:', error);
      }
    }
  }

  dispatchCartUpdated() {
   document.dispatchEvent(new CustomEvent('cart:refresh') );
  }
}

customElements.define('cart-progress-bar', CartProgressBar);
